// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_io-0";